import W, { css as f, createGlobalStyle as Y } from "styled-components";
import { ThemeContext as nt, ThemeProvider as at, createGlobalStyle as ot, css as it, keyframes as lt, withTheme as ft } from "styled-components";
const $ = 1e4;
function I(e) {
  return 1 - (1 - e) ** 1.685;
}
function K(e) {
  const r = I(e / 100), t = r === 0 ? 1 / $ : r;
  return `${e}% { transform: scaleY(${t}); }`;
}
function B(e) {
  const r = I(e / 100), t = r === 0 ? $ : 1 / r;
  return `${e}% { transform: scaleY(${t}); }`;
}
function Z(e) {
  const r = I(1 - e / 100), t = r === 0 ? 1 / $ : r;
  return `${e}% { transform: scaleY(${t}); }`;
}
function J(e) {
  const r = I(1 - e / 100), t = r === 0 ? $ : 1 / r;
  return `${e}% { transform: scaleY(${t}); }`;
}
const Pe = `
  @keyframes expand {
    ${[
  ...new Array(101).keys()
].map(K).join(" ")}
  }
  @keyframes collapse {
    ${[
  ...new Array(101).keys()
].map(Z).join(" ")}
  }
`, Re = `
  @keyframes expandInverted {
    ${[
  ...new Array(101).keys()
].map(B).join(" ")}
  }
  @keyframes collapseInverted {
    ${[
  ...new Array(101).keys()
].map(J).join(" ")}
  }
`;
function Q(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function w(e, r) {
  return w = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, w(e, r);
}
function V(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, w(e, r);
}
function M(e) {
  return M = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, M(e);
}
function L(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function U() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function C(e, r, t) {
  return U() ? C = Reflect.construct : C = function(a, i, l) {
    var d = [null];
    d.push.apply(d, i);
    var c = Function.bind.apply(a, d), s = new c();
    return l && w(s, l.prototype), s;
  }, C.apply(null, arguments);
}
function E(e) {
  var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return E = function(n) {
    if (n === null || !L(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof r < "u") {
      if (r.has(n))
        return r.get(n);
      r.set(n, a);
    }
    function a() {
      return C(n, arguments, M(this).constructor);
    }
    return a.prototype = Object.create(n.prototype, {
      constructor: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), w(a, n);
  }, E(e);
}
var ee = {
  1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
  2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
  3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
  4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
  5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
  6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
  7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
  8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
  9: `Please provide a number of steps to the modularScale helper.

`,
  10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
  12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
  13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
  14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  16: `You must provide a template to this method.

`,
  17: `You passed an unsupported selector state to this method.

`,
  18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  23: `fontFace expects a name of a font-family.

`,
  24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  25: `fontFace expects localFonts to be an array.

`,
  26: `fontFace expects fileFormats to be an array.

`,
  27: `radialGradient requries at least 2 color-stops to properly render.

`,
  28: `Please supply a filename to retinaImage() as the first argument.

`,
  29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
  32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
  33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
  34: `borderRadius expects a radius value as a string or number as the second argument.

`,
  35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  36: `Property must be a string value.

`,
  37: `Syntax Error at %s.

`,
  38: `Formula contains a function that needs parentheses at %s.

`,
  39: `Formula is missing closing parenthesis at %s.

`,
  40: `Formula has too many closing parentheses at %s.

`,
  41: `All values in a formula must have the same unit or be unitless.

`,
  42: `Please provide a number of steps to the modularScale helper.

`,
  43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
  45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
  46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
  47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
  51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
  52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  53: `fontFace expects localFonts to be an array.

`,
  54: `fontFace expects fileFormats to be an array.

`,
  55: `fontFace expects a name of a font-family.

`,
  56: `linearGradient requries at least 2 color-stops to properly render.

`,
  57: `radialGradient requries at least 2 color-stops to properly render.

`,
  58: `Please supply a filename to retinaImage() as the first argument.

`,
  59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  61: `Property must be a string value.

`,
  62: `borderRadius expects a radius value as a string or number as the second argument.

`,
  63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
  65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
  66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
  67: `You must provide a template to this method.

`,
  68: `You passed an unsupported selector state to this method.

`,
  69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
  70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
  71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
  72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
  73: `Please provide a valid CSS variable.

`,
  74: `CSS variable not found and no default was provided.

`,
  75: `important requires a valid style object, got a %s instead.

`,
  76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
  77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
  78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function re() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  var n = r[0], a = [], i;
  for (i = 1; i < r.length; i += 1)
    a.push(r[i]);
  return a.forEach(function(l) {
    n = n.replace(/%[a-z]/, l);
  }), n;
}
var h = /* @__PURE__ */ function(e) {
  V(r, e);
  function r(t) {
    var n;
    if (process.env.NODE_ENV === "production")
      n = e.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + t + " for more information.") || this;
    else {
      for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++)
        i[l - 1] = arguments[l];
      n = e.call(this, re.apply(void 0, [ee[t]].concat(i))) || this;
    }
    return Q(n);
  }
  return r;
}(/* @__PURE__ */ E(Error));
function P(e) {
  return Math.round(e * 255);
}
function te(e, r, t) {
  return P(e) + "," + P(r) + "," + P(t);
}
function G(e, r, t, n) {
  if (n === void 0 && (n = te), r === 0)
    return n(t, t, t);
  var a = (e % 360 + 360) % 360 / 60, i = (1 - Math.abs(2 * t - 1)) * r, l = i * (1 - Math.abs(a % 2 - 1)), d = 0, c = 0, s = 0;
  a >= 0 && a < 1 ? (d = i, c = l) : a >= 1 && a < 2 ? (d = l, c = i) : a >= 2 && a < 3 ? (c = i, s = l) : a >= 3 && a < 4 ? (c = l, s = i) : a >= 4 && a < 5 ? (d = l, s = i) : a >= 5 && a < 6 && (d = i, s = l);
  var p = t - i / 2, g = d + p, b = c + p, S = s + p;
  return n(g, b, S);
}
var A = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function ne(e) {
  if (typeof e != "string")
    return e;
  var r = e.toLowerCase();
  return A[r] ? "#" + A[r] : e;
}
var ae = /^#[a-fA-F0-9]{6}$/, oe = /^#[a-fA-F0-9]{8}$/, ie = /^#[a-fA-F0-9]{3}$/, le = /^#[a-fA-F0-9]{4}$/, R = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i, fe = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i, de = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, se = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
function ce(e) {
  if (typeof e != "string")
    throw new h(3);
  var r = ne(e);
  if (r.match(ae))
    return {
      red: parseInt("" + r[1] + r[2], 16),
      green: parseInt("" + r[3] + r[4], 16),
      blue: parseInt("" + r[5] + r[6], 16)
    };
  if (r.match(oe)) {
    var t = parseFloat((parseInt("" + r[7] + r[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + r[1] + r[2], 16),
      green: parseInt("" + r[3] + r[4], 16),
      blue: parseInt("" + r[5] + r[6], 16),
      alpha: t
    };
  }
  if (r.match(ie))
    return {
      red: parseInt("" + r[1] + r[1], 16),
      green: parseInt("" + r[2] + r[2], 16),
      blue: parseInt("" + r[3] + r[3], 16)
    };
  if (r.match(le)) {
    var n = parseFloat((parseInt("" + r[4] + r[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + r[1] + r[1], 16),
      green: parseInt("" + r[2] + r[2], 16),
      blue: parseInt("" + r[3] + r[3], 16),
      alpha: n
    };
  }
  var a = R.exec(r);
  if (a)
    return {
      red: parseInt("" + a[1], 10),
      green: parseInt("" + a[2], 10),
      blue: parseInt("" + a[3], 10)
    };
  var i = fe.exec(r.substring(0, 50));
  if (i)
    return {
      red: parseInt("" + i[1], 10),
      green: parseInt("" + i[2], 10),
      blue: parseInt("" + i[3], 10),
      alpha: parseFloat("" + i[4])
    };
  var l = de.exec(r);
  if (l) {
    var d = parseInt("" + l[1], 10), c = parseInt("" + l[2], 10) / 100, s = parseInt("" + l[3], 10) / 100, p = "rgb(" + G(d, c, s) + ")", g = R.exec(p);
    if (!g)
      throw new h(4, r, p);
    return {
      red: parseInt("" + g[1], 10),
      green: parseInt("" + g[2], 10),
      blue: parseInt("" + g[3], 10)
    };
  }
  var b = se.exec(r.substring(0, 50));
  if (b) {
    var S = parseInt("" + b[1], 10), q = parseInt("" + b[2], 10) / 100, X = parseInt("" + b[3], 10) / 100, F = "rgb(" + G(S, q, X) + ")", v = R.exec(F);
    if (!v)
      throw new h(4, r, F);
    return {
      red: parseInt("" + v[1], 10),
      green: parseInt("" + v[2], 10),
      blue: parseInt("" + v[3], 10),
      alpha: parseFloat("" + b[4])
    };
  }
  throw new h(5);
}
var D = function(r) {
  return r.length === 7 && r[1] === r[2] && r[3] === r[4] && r[5] === r[6] ? "#" + r[1] + r[3] + r[5] : r;
};
function u(e) {
  var r = e.toString(16);
  return r.length === 1 ? "0" + r : r;
}
function j(e, r, t) {
  if (typeof e == "number" && typeof r == "number" && typeof t == "number")
    return D("#" + u(e) + u(r) + u(t));
  if (typeof e == "object" && r === void 0 && t === void 0)
    return D("#" + u(e.red) + u(e.green) + u(e.blue));
  throw new h(6);
}
function T(e, r, t, n) {
  if (typeof e == "string" && typeof r == "number") {
    var a = ce(e);
    return "rgba(" + a.red + "," + a.green + "," + a.blue + "," + r + ")";
  } else {
    if (typeof e == "number" && typeof r == "number" && typeof t == "number" && typeof n == "number")
      return n >= 1 ? j(e, r, t) : "rgba(" + e + "," + r + "," + t + "," + n + ")";
    if (typeof e == "object" && r === void 0 && t === void 0 && n === void 0)
      return e.alpha >= 1 ? j(e.red, e.green, e.blue) : "rgba(" + e.red + "," + e.green + "," + e.blue + "," + e.alpha + ")";
  }
  throw new h(7);
}
const me = typeof W == "function" ? W : W.default, Te = me, ze = f`
  @keyframes ripple {
    0% {
      box-shadow: 0px 0px 0px 1px ${(e) => T(e.theme.colors.interface, 0)};
    }
    50% {
      box-shadow: 0px 0px 0px 15px ${(e) => T(e.theme.colors.interface, 0.1)};
    }
    100% {
      box-shadow: 0px 0px 0px 15px ${(e) => T(e.theme.colors.interface, 0)};
    }
  }
  animation: ripple 0.3s linear forwards;
`, H = 1440, be = H - 1, N = 1024, pe = N - 1, O = 768, ge = O - 1, o = {
  sm: {
    minScreenWidth: 0,
    maxScreenWidth: ge,
    maxContainerWidth: void 0,
    margin: 16,
    gutter: 16
  },
  md: {
    minScreenWidth: O,
    maxScreenWidth: pe,
    maxContainerWidth: 608,
    margin: 32,
    gutter: 16
  },
  lg: {
    minScreenWidth: N,
    maxScreenWidth: be,
    maxContainerWidth: void 0,
    margin: 32,
    gutter: 24
  },
  xl: {
    minScreenWidth: H,
    maxScreenWidth: Number.POSITIVE_INFINITY,
    maxContainerWidth: 1312,
    margin: 64,
    gutter: 32
  }
};
function k(e) {
  return function(t, ...n) {
    return f`
      @media only screen and (min-width: ${e}px) {
        ${f(t, ...n)};
      }
    `;
  };
}
function z(e) {
  return function(t, ...n) {
    return f`
      @media only screen and (max-width: ${e}px) {
        ${f(t, ...n)};
      }
    `;
  };
}
function _(e, r) {
  return function(n, ...a) {
    return f`
      @media only screen and (min-width: ${e}px) and (max-width: ${r}px) {
        ${f(n, ...a)};
      }
    `;
  };
}
const y = {
  maxSm: z(o.sm.maxScreenWidth),
  maxMd: z(o.md.maxScreenWidth),
  maxLg: z(o.lg.maxScreenWidth),
  minMd: k(o.md.minScreenWidth),
  minLg: k(o.lg.minScreenWidth),
  minXl: k(o.xl.minScreenWidth),
  sm: _(o.sm.minScreenWidth, o.sm.maxScreenWidth),
  md: _(o.md.minScreenWidth, o.md.maxScreenWidth),
  lg: _(o.lg.minScreenWidth, o.lg.maxScreenWidth),
  xl: k(o.xl.minScreenWidth)
};
function _e(e = "margin", r = 1, t = 0) {
  return f({
    [e]: `${o.sm.margin * r + t}px`
  }, y.minMd({
    [e]: `${o.md.margin * r + t}px`
  }), y.minLg({
    [e]: `${o.lg.margin * r + t}px`
  }), y.minXl({
    [e]: `${o.xl.margin * r + t}px`
  }));
}
function Me(e = "padding", r = 1, t = 0) {
  return f({
    [e]: `${o.sm.gutter * r + t}px`
  }, y.minMd({
    [e]: `${o.md.gutter * r + t}px`
  }), y.minLg({
    [e]: `${o.lg.gutter * r + t}px`
  }), y.minXl({
    [e]: `${o.xl.gutter * r + t}px`
  }));
}
const Ee = "@media not all and (hover: none), (-ms-high-contrast: none)", Fe = "@media (hover: none)", Ge = f`
  user-select: none;
  -webkit-tap-highlight-color: transparent;
`, Ae = f`
  -webkit-mask-image: -webkit-radial-gradient(white, black);
`, De = f`
  touch-action: manipulation;
`, je = f`
  background: none;
  border: none;
  display: inline-block;
  font: inherit;
  margin: 0;
  padding: 0;
  &::-moz-focus-inner {
    border: none;
    padding: 0;
  }
`;
function He({ top: e = "0px", right: r = "0px", bottom: t = "0px", left: n = "0px", position: a = "absolute" } = {}) {
  return f`
    position: ${a};
    top: ${e};
    left: ${n};
    right: ${r};
    bottom: ${t};
  `;
}
const Ne = f`
  outline: 2px solid #7aacfe; /* for non-webkit browsers */
  outline: 5px auto -webkit-focus-ring-color;
`;
function Oe(e, r) {
  return (t) => r[t[e]];
}
const qe = (e, r) => (e.defaultProps = r, e), ue = f`
  /* normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */

  /* Document
   ========================================================================== */

  /**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

  html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }

  /* Sections
   ========================================================================== */

  /**
 * Remove the margin in all browsers.
 */

  body {
    margin: 0;
  }

  /**
 * Correct the font size and margin on 'h1' elements within 'section' and
 * 'article' contexts in Chrome, Firefox, and Safari.
 */

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  /* Grouping content
   ========================================================================== */

  /**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  /**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd 'em' font sizing in all browsers.
 */

  pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /* Text-level semantics
   ========================================================================== */

  /**
 * Remove the gray background on active links in IE 10.
 */

  a {
    background-color: transparent;
  }

  /**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

  abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
  }

  /**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

  b,
  strong {
    font-weight: bolder;
  }

  /**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd 'em' font sizing in all browsers.
 */

  code,
  kbd,
  samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /**
 * Add the correct font size in all browsers.
 */

  small {
    font-size: 80%;
  }

  /**
 * Prevent 'sub' and 'sup' elements from affecting the line height in
 * all browsers.
 */

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /* Embedded content
   ========================================================================== */

  /**
 * Remove the border on images inside links in IE 10.
 */

  img {
    border-style: none;
  }

  /* Forms
   ========================================================================== */

  /**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
  }

  /**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

  button,
  input {
    /* 1 */
    overflow: visible;
  }

  /**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
 * Correct the inability to style clickable types in iOS and Safari.
 */

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  /**
 * Remove the inner border and padding in Firefox.
 */

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
 * Restore the focus styles unset by the previous rule.
 */

  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
 * Correct the padding in Firefox.
 */

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  /**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from 'fieldset' elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    'fieldset' elements in all browsers.
 */

  legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }

  /**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

  progress {
    vertical-align: baseline;
  }

  /**
 * Remove the default vertical scrollbar in IE 10+.
 */

  textarea {
    overflow: auto;
  }

  /**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */

  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  /**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  /**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

  [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  /**
 * Remove the inner padding in Chrome and Safari on macOS.
 */

  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to 'inherit' in Safari.
 */

  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  /* Interactive
   ========================================================================== */

  /*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */

  details {
    display: block;
  }

  /*
 * Add the correct display in all browsers.
 */

  summary {
    display: list-item;
  }

  /* Misc
   ========================================================================== */

  /**
 * Add the correct display in IE 10+.
 */

  template {
    display: none;
  }

  /**
 * Add the correct display in IE 10.
 */

  [hidden] {
    display: none;
  }
`, Xe = "#ffffff", Ye = "#4957f4", Ke = "#000000", Be = " #606060", Ze = "#7f7f7f", Je = "#bfbfbf", Qe = "#fafafa", Ve = "#e6e6e6", Le = "#c4c4c4", Ue = "#e02d21", er = "#dfdfdf", rr = "#606060", tr = "#161616", nr = "#dfdfdf", ar = "#747474", or = "#979797", ir = "#091652", lr = "#996D15", fr = "#a7782b", dr = "#835d12", sr = [
  {
    title: "core colors",
    colors: [
      {
        name: "indigo",
        code: "#4957f4"
      },
      {
        name: "black",
        code: "#000000"
      },
      {
        name: "darkestGrey",
        code: "#404040"
      },
      {
        name: "darkGrey",
        code: "#606060"
      },
      {
        name: "grey",
        code: "#7f7f7f"
      },
      {
        name: "lightGrey",
        code: "#bfbfbf"
      },
      {
        name: "disabledGrey",
        code: "#dfdfdf"
      },
      {
        name: "lightestGrey",
        code: "#f8f8f8"
      },
      {
        name: "white",
        code: "#fff"
      },
      {
        name: "errorRed",
        code: "#E02D21"
      },
      {
        name: "darkgrey1",
        code: "#747474"
      },
      {
        name: "outlineColor",
        code: "#091652"
      }
    ]
  },
  {
    title: "Property Colors",
    colors: [
      {
        name: "aria_bp",
        code: "#002b49"
      },
      {
        name: "aria_ip",
        code: "#002b49"
      },
      {
        name: "beaurivage_bp",
        code: "#002b49"
      },
      {
        name: "beaurivage_ip",
        code: "#002b49"
      },
      {
        name: "bellagio_bp",
        code: "#005B70"
      },
      {
        name: "bellagio_ip",
        code: "#005B70"
      },
      {
        name: "delano_bp",
        code: "#7E8083"
      },
      {
        name: "delano_ip",
        code: "#7E8083"
      },
      {
        name: "excalibur_bp",
        code: "#572D2D"
      },
      {
        name: "excalibur_ip",
        code: "#572D2D"
      },
      {
        name: "goldstrike_bp",
        code: "#333333"
      },
      {
        name: "goldstrike_ip",
        code: "#333333"
      },
      {
        name: "luxor_bp",
        code: "#007BBE"
      },
      {
        name: "luxor_ip",
        code: "#007BBE"
      },
      {
        name: "mandalaybay_bp",
        code: "#E6B136"
      },
      {
        name: "mandalaybay_ip",
        code: "#000000"
      },
      {
        name: "mgmdetroit_bp",
        code: "#84714D"
      },
      {
        name: "mgmdetroit_ip",
        code: "#84714D"
      },
      {
        name: "mgmgrand_bp",
        code: "#006666"
      },
      {
        name: "mgmgrand_ip",
        code: "#006666"
      },
      {
        name: "mgmnationalharbour_bp",
        code: "#01718A"
      },
      {
        name: "mgmnationalharbour_ip",
        code: "#01718A"
      },
      {
        name: "mgmri_bp",
        code: "#996D15"
      },
      {
        name: "mgmri_ip",
        code: "#996D15"
      },
      {
        name: "mgmspringfield_bp",
        code: "#3F6C7D"
      },
      {
        name: "mgmspringfield_ip",
        code: "#3F6C7D"
      },
      {
        name: "mirage_bp",
        code: "#17586D"
      },
      {
        name: "mirage_ip",
        code: "#17586D"
      },
      {
        name: "nomad_bp",
        code: "#612141"
      },
      {
        name: "nomad_ip",
        code: "#612141"
      },
      {
        name: "northfieldpark_bp",
        code: "#AB2328"
      },
      {
        name: "northfieldpark_ip",
        code: "#000000"
      },
      {
        name: "nyny_bp",
        code: "#024F80"
      },
      {
        name: "nyny_ip",
        code: "#024F80"
      },
      {
        name: "parkmgm_bp",
        code: "#7B794C"
      },
      {
        name: "parkmgm_ip",
        code: "#7B794C"
      },
      {
        name: "signature_bp",
        code: "#595A3D"
      },
      {
        name: "signature_ip",
        code: "#595A3D"
      },
      {
        name: "vdara_bp",
        code: "#71655F"
      },
      {
        name: "vdara_ip",
        code: "#71655F"
      }
    ]
  }
], cr = {
  rootVariable: "MGM-"
}, mr = "0.25rem", br = "0.5rem", pr = "0.75rem", gr = "1rem", ur = "1.5rem", hr = "2rem", yr = "4rem", he = "Calibre-R ,sans-serif", xr = "0.625rem", wr = "0.75rem", vr = "0.75rem", kr = "0.7srem", Cr = "1rem", $r = "1rem", Ir = "1rem", Sr = "1rem", ye = "1.25rem", xe = "1.75rem", we = "2.188rem", ve = "2.5rem", ke = "2.812rem", m = `
  font-family: ${he};
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
`, Wr = () => `${m}
    font-size: ${ke};
    line-height: 1.07;
    letter-spacing: -0.3px;`, Pr = () => `${m}
    font-size: ${ve};
    line-height: 1;
    letter-spacing: -1px;`, Rr = () => `${m}
    font-size: ${we};
    line-height: 1.14;
    letter-spacing: normal;`, Tr = () => `${m}
    font-size: ${xe};
    line-height: 1.25;
    letter-spacing: normal;`, zr = () => `${m}
    font-size: ${ye};
    line-height: 1.2;
    letter-spacing: normal;`, _r = () => `${m}
    font-size: 12px;
    line-height: 1.67;
    letter-spacing: normal;`, Mr = () => `${m}
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: normal;`, Er = () => `${m}
    font-size: 10px;
    line-height: 1.2;
    letter-spacing: normal;`, Fr = () => `${m}
    font-size: 14px;
    line-height: 1.375;
    letter-spacing: normal;`, Gr = 1e3, Ar = (e) => e - 2, Dr = (e) => e - 1, jr = 1022, Hr = (e) => e + 1, Nr = (e) => e + 2, Or = (e) => e + 3, qr = (e) => e + 4, Xr = (e) => e + 5, Yr = (e) => e + 6, Kr = 10, Ce = {
  aria: {
    brandPrimaryColor: "#002b49"
  },
  beaurivage: {
    brandPrimaryColor: "#2664ac"
  },
  bellagio: {
    brandPrimaryColor: "#005b70"
  },
  borgata: {
    brandPrimaryColor: "#3f2767"
  },
  delanolasvegas: {
    brandPrimaryColor: "#7e8083"
  },
  empirecitycasino: {
    brandPrimaryColor: "#000000",
    interfacePrimaryColor: "#1c1b1c"
  },
  excalibur: {
    brandPrimaryColor: "#572d2d"
  },
  goldstrike: {
    brandPrimaryColor: "#333"
  },
  luxor: {
    brandPrimaryColor: "#007b8e"
  },
  mandalaybay: {
    brandPrimaryColor: "#e6b135",
    interfacePrimaryColor: "#556b8a"
  },
  mgmgrand: {
    brandPrimaryColor: "#716443"
  },
  mgmgranddetroit: {
    brandPrimaryColor: "#84724d"
  },
  mgmnationalharbor: {
    brandPrimaryColor: "#082437"
  },
  mgmnorthfieldpark: {
    brandPrimaryColor: "#0c3246",
    interfacePrimaryColor: "#1c1b1c"
  },
  mgmspringfield: {
    brandPrimaryColor: "#3f6c7d"
  },
  mgmresorts: {
    brandPrimaryColor: "#996d15",
    interfacePrimaryColor: "#4957f4"
  },
  mirage: {
    brandPrimaryColor: "#17586d"
  },
  newyorknewyork: {
    brandPrimaryColor: "#024f80"
  },
  nomadlasvegas: {
    brandPrimaryColor: "#612141"
  },
  parkmgm: {
    brandPrimaryColor: "#5b794c"
  },
  signaturemgmgrand: {
    brandPrimaryColor: "#695a3d"
  },
  vdara: {
    brandPrimaryColor: "#71655f"
  },
  cosmopolitanlasvegas: {
    brandPrimaryColor: "#612c73"
  },
  wlasvegas: {
    brandPrimaryColor: "#000000"
  }
}, $e = {
  buttonTransitionDuration: "0.3s",
  buttonTransitionTimingFn: "ease-in-out",
  mobileNavigationHeight: 52,
  desktopNavigationHeight: 76,
  tabletFixedButtonHeight: 66,
  desktopFixedButtonHeight: 82,
  space: [],
  breakpoints: [
    `${o.md.minScreenWidth}px`,
    `${o.lg.minScreenWidth}px`,
    `${o.xl.minScreenWidth}px`
  ]
}, Ie = {
  black: "#000",
  darkestGrey: "#404040",
  darkGrey: "#606060",
  grey: "#7f7f7f",
  lightGrey: "#bfbfbf",
  disabledGrey: "#dfdfdf",
  lightestGrey: "#f8f8f8",
  white: "#fff",
  errorRed: "#e02d21",
  darkGrey1: "#747474",
  outlineColor: "#091652"
};
function Br(e) {
  const { brandPrimaryColor: r, interfacePrimaryColor: t } = Ce[e];
  return {
    ...$e,
    colors: {
      brand: r,
      interface: t || r,
      ...Ie
    }
  };
}
const Zr = [
  "aria",
  "beaurivage",
  "bellagio",
  "borgata",
  "delanolasvegas",
  "excalibur",
  "empirecitycasino",
  "goldstrike",
  "luxor",
  "mandalaybay",
  "mgmgrand",
  "mgmgranddetroit",
  "mgmnationalharbor",
  "mgmnorthfieldpark",
  "mgmspringfield",
  "mgmresorts",
  "mirage",
  "newyorknewyork",
  "nomadlasvegas",
  "parkmgm",
  "signaturemgmgrand",
  "vdara",
  "cosmopolitanlasvegas",
  "wlasvegas"
], x = {
  aria: {
    websiteTitle: "ARIA Resort & Casino",
    id: "e2704b04-d515-45b0-8afd-4fa1424ff0a8",
    regionId: "las-vegas",
    ticker: "aria"
  },
  beaurivage: {
    websiteTitle: "Beau Rivage Resort & Casino",
    id: "13b178b0-8beb-43d5-af25-1738b7267e63",
    regionId: "mississippi",
    ticker: "beau"
  },
  bellagio: {
    websiteTitle: "Bellagio Hotel & Casino",
    id: "44e610ab-c209-4232-8bb4-51f7b9b13a75",
    regionId: "las-vegas",
    ticker: "bell"
  },
  borgata: {
    websiteTitle: "Borgata Hotel & Casino",
    id: "773000cc-468a-4d86-a38f-7ae78ecfa6aa",
    regionId: "new-jersey",
    ticker: "borg"
  },
  delanolasvegas: {
    websiteTitle: "Delano Las Vegas",
    id: "8bf670c2-3e89-412b-9372-6c87a215e442",
    regionId: "las-vegas",
    ticker: "dlno"
  },
  empirecitycasino: {
    websiteTitle: "Empire City Casino",
    id: "e0ef39b2-5eea-43ff-a734-b10217571eaa",
    regionId: "new-york",
    ticker: "empr"
  },
  excalibur: {
    websiteTitle: "Excalibur Hotel & Casino",
    id: "f8d6a944-7816-412f-a39a-9a63aad26833",
    regionId: "las-vegas",
    ticker: "exca"
  },
  goldstrike: {
    websiteTitle: "Gold Strike Casino Resort",
    id: "b35733d1-e027-4311-a350-965e535fb90a",
    regionId: "mississippi",
    ticker: "tnca"
  },
  luxor: {
    websiteTitle: "Luxor Hotel & Casino",
    id: "607c07e7-3e31-4e4c-a4e1-f55dca66fea2",
    regionId: "las-vegas",
    ticker: "luxr"
  },
  mandalaybay: {
    websiteTitle: "Mandalay Bay",
    id: "e0f70eb3-7e27-4c33-8bcd-f30bf3b1103a",
    regionId: "las-vegas",
    ticker: "mbay"
  },
  mgmgrand: {
    websiteTitle: "MGM Grand Las Vegas",
    id: "66964e2b-2550-4476-84c3-1a4c0c5c067f",
    regionId: "las-vegas",
    ticker: "mgmg"
  },
  mgmgranddetroit: {
    websiteTitle: "MGM Grand Detroit",
    id: "4a65a92a-962b-433e-841c-37e18dc5d68d",
    regionId: "detroit",
    ticker: "mgmgd"
  },
  mgmnationalharbor: {
    websiteTitle: "MGM National Harbor",
    id: "0990fdce-7fc8-41b1-b8b6-9a25dce3db55",
    regionId: "maryland",
    ticker: "mgmnh"
  },
  mgmnorthfieldpark: {
    websiteTitle: "MGM Northfield Park",
    id: "00ccdea6-7d78-410b-b0f0-5983bdf44cc2",
    regionId: "ohio",
    ticker: "mgmnp"
  },
  mgmspringfield: {
    websiteTitle: "MGM Springfield",
    id: "40b61feb-750a-45df-ae68-e23e6272b16b",
    regionId: "massachusetts",
    ticker: "mgmsp"
  },
  mgmresorts: {
    websiteTitle: "MGM Resorts",
    id: "mgmresorts",
    regionId: "las-vegas",
    isMultiPropertyWebsite: !0,
    ticker: "mgmr"
  },
  mirage: {
    websiteTitle: "The Mirage",
    id: "a689885f-cba2-48e8-b8e0-1dff096b8835",
    regionId: "las-vegas",
    ticker: "mira"
  },
  newyorknewyork: {
    websiteTitle: "New York-New York Hotel & Casino",
    id: "dc00e77f-d6bb-4dd7-a8ea-dc33ee9675ad",
    regionId: "las-vegas",
    ticker: "nyny"
  },
  nomadlasvegas: {
    websiteTitle: "NoMad Las Vegas",
    id: "2159252c-60d3-47db-bbae-b1db6bb15072",
    regionId: "las-vegas",
    ticker: "nomd"
  },
  parkmgm: {
    websiteTitle: "Park MGM",
    id: "bee81f88-286d-43dd-91b5-3917d9d62a68",
    regionId: "las-vegas",
    ticker: "pmgm"
  },
  signaturemgmgrand: {
    websiteTitle: "The Signature at MGM Grand",
    id: "1f3ed672-3f8f-44d8-9215-81da3c845d83",
    regionId: "las-vegas",
    ticker: "sign"
  },
  vdara: {
    websiteTitle: "Vdara Hotel & Spa",
    id: "6c5cff3f-f01a-4f9b-87ab-8395ae8108db",
    regionId: "las-vegas",
    ticker: "vdar"
  },
  cosmopolitanlasvegas: {
    websiteTitle: "",
    id: "",
    regionId: "",
    ticker: ""
  },
  wlasvegas: {
    websiteTitle: "",
    id: "",
    regionId: "",
    ticker: ""
  }
};
function Se(e) {
  return Object.values(x).find((r) => r.id === e);
}
function Jr(e) {
  var r;
  return (r = Se(e)) == null ? void 0 : r.regionId;
}
function Qr(e) {
  return x[e].regionId;
}
function Vr(e) {
  return x[e].id;
}
function Lr(e) {
  return x[e].ticker;
}
function Ur(e) {
  return Object.keys(x).find((r) => x[r].id === e);
}
const et = Y`
${ue}

* {
  box-sizing: border-box;
}

html {
  /* ios opera momentum scrolling */
  -webkit-overflow-scrolling: touch;
}

body {
  min-height: 100vh;
  padding: 0;
  margin: 0;
  background-color: #fff;

  font-family: 'Calibre-R', sans-serif;
  font-size: 16px;
  line-height: 1.25em;
  color: #606060;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* ios safari momentum scrolling */
  -webkit-overflow-scrolling: touch;
}

h1,
h2,
h3,
h4,
h5,
h6,
blockquote {
  margin: 0;
}

/* no outline for non-keyboard-inputs elements */
*:focus {
  outline-offset: 0;
  outline-width: 0;
}

@media screen and (max-width: ${o.sm.maxScreenWidth}px) {
  input, textarea {
    font-size: 16px;
  }
}

${({ assetsBaseURL: e = "https://static.mgmresorts.com/content/dam/MGM/direct/vega/fonts" }) => `
  /* thin */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 100;
    font-style: normal;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-Thin.eot?#iefix');
    src: url('${e}/Calibre-RWeb-Thin.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-Thin.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-Thin.woff') format('woff');
  }

  /* thin italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 100;
    font-style: italic;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-ThinItalic.eot?#iefix');
    src: url('${e}/Calibre-RWeb-ThinItalic.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-ThinItalic.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-ThinItalic.woff') format('woff');
  }

  /* light */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 300;
    font-style: normal;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-Light.eot?#iefix');
    src: url('${e}/Calibre-RWeb-Light.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-Light.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-Light.woff') format('woff');
  }

  /* light italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 300;
    font-style: italic;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-LightItalic.eot?#iefix');
    src: url('${e}/Calibre-RWeb-LightItalic.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-LightItalic.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-LightItalic.woff') format('woff');
  }

  /* regular */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 400;
    font-style: normal;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-Regular.eot?#iefix');
    src: url('${e}/Calibre-RWeb-Regular.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-Regular.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-Regular.woff') format('woff');
  }

  /* regular italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 400;
    font-style: italic;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-RegularItalic.eot?#iefix');
    src: url('${e}/Calibre-RWeb-RegularItalic.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-RegularItalic.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-RegularItalic.woff') format('woff');
  }

  /* medium */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 500;
    font-style: normal;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-Medium.eot?#iefix');
    src: url('${e}/Calibre-RWeb-Medium.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-Medium.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-Medium.woff') format('woff');
  }

  /* medium italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 500;
    font-style: italic;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-MediumItalic.eot?#iefix');
    src: url('${e}/Calibre-RWeb-MediumItalic.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-MediumItalic.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-MediumItalic.woff') format('woff');
  }

  /* semibold */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 600;
    font-style: normal;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-Semibold.eot?#iefix');
    src: url('${e}/Calibre-RWeb-Semibold.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-Semibold.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-Semibold.woff') format('woff');
  }

  /* semibold italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 600;
    font-style: italic;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-SemiboldItalic.eot?#iefix');
    src: url('${e}/Calibre-RWeb-SemiboldItalic.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-SemiboldItalic.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-SemiboldItalic.woff') format('woff');
  }

  /* bold */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 700;
    font-style: normal;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-Bold.eot?#iefix');
    src: url('${e}/Calibre-RWeb-Bold.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-Bold.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-Bold.woff') format('woff');
  }

  /* bold italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 700;
    font-style: italic;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-BoldItalic.eot?#iefix');
    src: url('${e}/Calibre-RWeb-BoldItalic.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-BoldItalic.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-BoldItalic.woff') format('woff');
  }

  /* black */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 800;
    font-style: normal;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-Black.eot?#iefix');
    src: url('${e}/Calibre-RWeb-Black.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-Black.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-Black.woff') format('woff');
  }

  /* black italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 800;
    font-style: italic;

    font-display: fallback;
    src: url('${e}/Calibre-RWeb-BlackItalic.eot?#iefix');
    src: url('${e}/Calibre-RWeb-BlackItalic.eot?#iefix') format('eot'),
      url('${e}/Calibre-RWeb-BlackItalic.woff2') format('woff2'),
      url('${e}/Calibre-RWeb-BlackItalic.woff') format('woff');
  }
`}
`;
export {
  Ke as $black,
  Cr as $body,
  Sr as $bodyBold,
  kr as $boldParagaph,
  Be as $dark,
  rr as $darkGrey,
  tr as $darkerGrey,
  er as $darkestGrey,
  ar as $darkgrey1,
  nr as $disabledGrey,
  Ue as $errorRed,
  he as $fontFamily,
  Ze as $grey,
  ke as $heading1,
  ve as $heading2,
  we as $heading3,
  xe as $heading4,
  ye as $heading5,
  Ye as $indigo,
  Ve as $lighestGrey3,
  Je as $lightestGrey,
  Qe as $lightestGrey2,
  Ir as $mediumBody,
  vr as $mediumParagaph,
  lr as $mgmriBp,
  fr as $mgmriBp2,
  dr as $mgmriBp3,
  ir as $outlineColor,
  wr as $paragraph,
  $r as $regularBody,
  or as $slightLightGrey,
  xr as $small,
  ur as $spacingLarge,
  gr as $spacingMedium,
  pr as $spacingSmall,
  br as $spacingXSmall,
  mr as $spacingXSmallSmall,
  hr as $spacingXtraLarge,
  yr as $spacingXtraXtraLarge,
  Le as $stoneGrey,
  Xe as $white,
  sr as Colors,
  cr as Global,
  et as GlobalStyle,
  nt as ThemeContext,
  at as ThemeProvider,
  Mr as bodyText,
  Br as buildThemeContext,
  Ie as colors,
  ot as createGlobalStyle,
  it as css,
  Re as expandCollapseInvertedKeyframes,
  Pe as expandCollapseKeyframes,
  Se as getPropertyConfigById,
  Vr as getPropertyIdByPropertySlug,
  Ur as getPropertyNameByResortId,
  Lr as getPropertyTickerByPropertySlug,
  Qr as getRegionIdByPropertySlug,
  Jr as getRegionIdByResortId,
  o as gridDimensions,
  Wr as h1,
  Pr as h2,
  Rr as h3,
  Tr as h4,
  zr as h5,
  Fe as isHoverNotSupported,
  Ee as isHoverSupported,
  Ne as keyboardFocusIndicator,
  lt as keyframes,
  y as media,
  Fr as mediumText,
  ue as normalize,
  _r as paragraphText,
  De as preventDoubleTapToZoom,
  Ge as preventTextSelect,
  x as propertyConfigs,
  Zr as propertySlugs,
  je as resetDefaultButtonStyles,
  ze as rippleAnimation,
  Ae as safariOverflowFix,
  Me as screenGutterProperty,
  _e as screenMarginProperty,
  k as screenWidthAbove,
  z as screenWidthBelow,
  _ as screenWidthBetween,
  Er as smallText,
  He as stretch,
  Te as styled,
  $e as th,
  Ce as themeBrandConfigs,
  $e as themeConsts,
  Oe as variant,
  qe as withDefaultProps,
  ft as withTheme,
  Gr as zMainNavigation,
  Ar as zModalBackdrop,
  jr as zModalBase,
  Yr as zModalFixedButton,
  Xr as zModalHeader,
  Kr as zModalIncrementValue,
  Hr as zModalInner,
  Nr as zModalInner2,
  Or as zModalInner2MouseBackdrop,
  qr as zModalInner3,
  Dr as zModalMouseBackdrop
};
